import ContainerCard from '../../../../common/components/ContainerCard';
import { ICustomerItem } from '../../../../models/Account/ICustomerItem';
import styles2 from '../../AccountPage.module.css';
import CredentialCard from './components';
import styles from './CredentialsSection.module.css';

type CredentialsProps = {
  credentials: ICustomerItem[];
  qualifications: ICustomerItem[];
};

const CredentialsSection = (props: CredentialsProps) => {
  let elements: ICustomerItem[] = [];
  if (props.credentials || props.qualifications) {
    elements = [...(props.credentials || []), ...(props.qualifications || [])];
  }
  return (
    <ContainerCard className={styles2.cardDimensions + ' ' + styles2.cardStrech}>
      <div className={styles.title}>Credentials</div>
      <div className={styles.credentialsCardContainer}>
        {elements?.map((credential, index) => {
          return <CredentialCard credentialData={credential} key={index} />;
        })}
      </div>
    </ContainerCard>
  );
};

export default CredentialsSection;
